import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Global } from "../global";
import { Components } from "../shared/components/components";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { CertificadosNacionaisModel } from "../certificados-nacionais/certificados-nacionais.model";
import { CertificadosNacionaisService } from '../certificados-nacionais/certificados-nacionais.service';
import { ClientesService } from '../clientes/clientes.service';
import { MercadoInternoMercadoriasService } from "../mercado-interno-mercadorias/mercado-interno-mercadorias.service";
import { FaturasService } from "../faturas/faturas.service";
import { BasicValidators } from "../shared/basic-validators";

declare let swal, $: any;

@Component({
  selector: 'app-financeiro-certificados-nacionais-cliente',
  templateUrl: './financeiro-certificados-nacionais-cliente.component.html'
})
export class FinanceiroCertificadosNacionaisClienteComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  formFaturar: FormGroup;

  filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "numero": "", "numero_analise": "", "id_cliente": "", "id_mercadoria": "", "lote": "" };

  faturarEmMassa = {
    "data": "",
    "taxa_laboratorial": ""
  };

  carregandoBotaoFaturar: boolean = false;

  certificados: CertificadosNacionaisModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };
  podeFaturar = false;

  listStatus = [];
  listMercadorias = [];
  certificadosSelecionados = [];

  checkAll = false;
  mesAtual;
  idCliente: string;
  cliente: any = null;

  constructor(
    formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private certificadosService: CertificadosNacionaisService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    this.mesAtual = new Date();
    this.mesAtual = new Date(this.mesAtual.getFullYear(), this.mesAtual.getMonth(), 1).setHours(0, 0, 0, 0);

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao[0].url == 'certificados-nacionais') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        } else if (data.privilegios[i].acao[0].url == 'financeiro') {
          this.podeFaturar = data.privilegios[i].editar;
        }
      }
      if (this.func.userIsMaster()) {
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      data_de: [],
      data_ate: [],
      id_mercadoria: [],
      numero: [],
      numero_analise: [],
      lote: [],
      status_pesquisa: []
    });

    this.formFaturar = formBuilder.group({
      data_faturar_massa: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      taxa_laboratorial: ['', [
        Validators.required,
        BasicValidators.notNull
      ]]
    });

    this.listStatus = this.func.nomesStatusCertificado();

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload || [];
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idCliente = params['id_cliente'];
      this.filtroPesquisa.id_cliente = this.idCliente;

      if (this.idCliente) {
        this.clientesService.getById(this.idCliente)
          .subscribe(
            json => {
              if (json && json.Payload && json.Payload.length > 0) {
                this.cliente = json.Payload[0];
              }
            },
            error => {
              this.func.showErro(error.json());
            }
          );
      }

      this.getPage(1);
    });
  }

  getTipoFaturamentoTexto(tipo: string): string {
    if (!tipo) {
      return 'Taxa Fixa';
    }
    switch (tipo) {
      case 'taxa_fixa':
        return 'Taxa Fixa';
      case 'peso':
        return 'Peso';
      case 'peso_taxa':
        return 'Peso + Taxa Fixa';
      default:
        return tipo;
    }
  }

  qtdItensPorPagina(event) {
    this.itensPorPagina = event.target.value;
    localStorage.setItem('itensPorPagina', event.target.value);
    this.getPage(1);
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    filtros['id_cliente'] = this.idCliente;
    filtros['faturado'] = '0';

    if (this.filtroPesquisa.status_pesquisa != '' && this.filtroPesquisa.status_pesquisa != null) {
      filtros['status_certificado'] = this.filtroPesquisa.status_pesquisa;
    }

    if (this.filtroPesquisa.data_de != '' && this.filtroPesquisa.data_de != null && this.filtroPesquisa.data_ate != '' && this.filtroPesquisa.data_ate != null) {
      filtros['data_emissao'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de != '' && this.filtroPesquisa.data_de != null) {
        filtros['data_emissao'] = 'ge:' + this.filtroPesquisa.data_de;
      }
      if (this.filtroPesquisa.data_ate != '' && this.filtroPesquisa.data_ate != null) {
        filtros['data_emissao'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if (this.filtroPesquisa.numero != '' && this.filtroPesquisa.numero != null) {
      filtros['numero'] = this.filtroPesquisa.numero;
    }

    if (this.filtroPesquisa.numero_analise != '' && this.filtroPesquisa.numero_analise != null) {
      filtros['numero_analise'] = this.filtroPesquisa.numero_analise;
    }

    if (this.filtroPesquisa.id_mercadoria != '' && this.filtroPesquisa.id_mercadoria != null) {
      filtros['id_mercadoria'] = this.filtroPesquisa.id_mercadoria;
    }

    if (this.filtroPesquisa.lote != '' && this.filtroPesquisa.lote != null) {
      filtros['lote'] = this.filtroPesquisa.lote;
    }

    this.certificadosService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria_listagem', 'cliente'], filtros, ["id_certificado_nacional", "id_mercadoria", "id_cliente", "status_certificado", "numero", "peso", "lote", "data_emissao", "faturado"], { "numero": "D" })
      .subscribe(data => {
        this.certificados = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(certificado) {
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarCertificado') + certificado.numero,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        let index = self.certificados.indexOf(certificado);
        self.certificados.splice(index, 1);

        self.certificadosService.apagar(certificado.id_certificado_nacional)
          .subscribe(res => {
          },
            err => {
              self.certificados.splice(index, 0, certificado);
              self.func.showErro(err.json());
            });
      });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "status_pesquisa": "", "data_de": "", "data_ate": "", "numero": "", "numero_analise": "", "id_cliente": this.idCliente, "id_mercadoria": "", "lote": "" };
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  changeSelectCertificado(id_certificado, event) {
    if (event.srcElement.checked) {
      this.certificadosSelecionados.push(event.target.value);
    } else {
      this.certificadosSelecionados = this.certificadosSelecionados.filter(item => item !== event.target.value);
    }
  }

  changeCheckAll(e) {
    this.checkAll = e.target.checked;
    this.certificadosSelecionados = [];

    if (e.target.checked) {
      for (let i in this.certificados) {
        this.certificadosSelecionados.push(this.certificados[i].id_certificado_nacional);
      }
    }
  }

  modalFaturarEmMassa() {
    let ids = this.certificadosSelecionados;
    if (!ids || ids.length === 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }
    this.faturarEmMassa["data"] = new Date().toISOString().substr(0, 10);
    this.faturarEmMassa["taxa_laboratorial"] = this.cliente ? (this.cliente.taxa_laboratorial || '0,00') : '0,00';
    this.formFaturar.patchValue({
      data_faturar_massa: this.faturarEmMassa["data"],
      taxa_laboratorial: this.faturarEmMassa["taxa_laboratorial"]
    });
    $('#modalFaturarEmMassa').modal('show');
  }

  confirmarFaturarEmMassa() {
    if (!this.formFaturar.valid) {
      return;
    }
    let ids = this.certificadosSelecionados;
    if (!ids || ids.length === 0) {
      return;
    }
    this.carregandoBotaoFaturar = true;
    this.faturasService.faturarCertificadosNacionaisAvulsos(ids, this.faturarEmMassa["data"], this.faturarEmMassa["taxa_laboratorial"])
      .subscribe(
        res => {
          this.carregandoBotaoFaturar = false;
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
          this.certificadosSelecionados = [];
          this.checkAll = false;
          this.getPage(this.paginaAtual);
          $('#modalFaturarEmMassa').modal('hide');
        },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro-certificados-nacionais-cliente.component.ts